import type { UseFormReturnType } from "@mantine/form";

import { Flex, Select } from "@mantine/core";

interface IvrHandoffFormValues {
    email: string;
    firstName: string;
    lastName: string;
    isInternationalCaller: boolean;
    currentPlan: string | null;
}

export function SalesQuestionnaire({
    form,
    plans,
}: {
    form: UseFormReturnType<IvrHandoffFormValues>;
    plans: string[];
}) {
    return (
        <Flex h="100%" mt="xl" direction="column">
            <Select
                onChange={(val) => {
                    form.setValues({
                        currentPlan: val,
                    });
                }}
                label="Plan name"
                allowDeselect={false}
                mt="xl"
                placeholder="Choose a plan"
                data={plans}
                key={form.key("currentPlan")}
            />
        </Flex>
    );
}
